import produce from 'immer';
import { combineReducers } from 'redux';
import { DownloadActionType, DownloadAction } from '../../actions/downloadActions';
import { InstallerInfo } from '../../types/resources';

type assistantDownloadByFileName = {
  [path: string]: InstallerInfo;
};

const byFileName = (state: assistantDownloadByFileName = {}, action: DownloadAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case DownloadActionType.GET_ASSISTANT_DOWNLOADS:
        return {};
      case DownloadActionType.GET_ASSISTANT_DOWNLOADS_OK: {
        action.data.forEach((installerInfo) => {
          draft[installerInfo.path] = installerInfo;
        });

        break;
      }
      default:
        return state;
    }
  });

const allNames = (state: string[] = [], action: DownloadAction) => {
  switch (action.type) {
    case DownloadActionType.GET_ASSISTANT_DOWNLOADS:
      return [];
    case DownloadActionType.GET_ASSISTANT_DOWNLOADS_OK:
      return action.data.map((installerInfo) => installerInfo.path);
    default:
      return state;
  }
};

export default combineReducers({ byFileName, allNames });
